<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    :class="[{ 'search-item': $route.name === 'SSearchResultQuery' }]"
    class="temporary-position"
  >
    <md-card
      class="snew-item-card"
      :class="[
        { lpCardSize: $route.name === 'landingPage' },
        { 'md-elevation-5': $route.name === 'landingPage' && !mouseEnter },
        { searchCardSize: $route.name === 'SSearchResultQuery' },
        { 'md-elevation-20': mouseEnter },
      ]"
      data-cy="lpItemPostBlock"
    >
      <md-card-header>
        <md-avatar class="profile-img skeleton">
          <img alt="Avatar" />
        </md-avatar>

        <div class="md-title header-content">
          <div class="profile-text">
            <div class="user-content skeleton">
              <span class="card-poster-name">Username</span>
            </div>

            <div class="md-subhead posted-info skeleton mt-1">PostDate</div>
          </div>
        </div>
      </md-card-header>

      <md-card-media class="cover-img skeleton">
        <div class="image">
          <img src="/img/swampum-logo.png" loading="lazy" alt="Item" />
        </div>
      </md-card-media>

      <md-card-content>
        <div class="head profile-cta">
          <div class="md-subhead item-subhead">
            <div class="item-card-title skeleton">
              <div
                class="poster-name-content mr-1"
                :class="[
                  { 'lp-poster-name-class': $route.name === 'landingPage' },
                ]"
              >
                Poster name
              </div>
            </div>
            <div class="state-content">
              <div class="state skeleton">State</div>
            </div>
          </div>
          <div class="md-title item-title skeleton">Title</div>
        </div>
        <div class="mt-4 item-description skeleton">Description</div>
        <div class="item-price skeleton">Action price</div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "SLazyCard",
  data() {
    return {
      mouseEnter: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.item-description {
  width: 280px;
  margin-bottom: 2rem;
}
.snew-item-card {
  width: 344px;
  height: 558px;
  margin-bottom: 2rem;
  border-radius: 4px;
  border: 1px solid $grey;
  overflow-x: hidden;
}

.searchCardSize {
  width: 325px !important;
}

.item-subhead {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  opacity: 1 !important;
}
.state {
  width: fit-content;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-weight: bold;
  border-radius: 12px;
  text-align: center;
  background-color: $dark;
  padding: 8px;
}
.md-card-media img {
  height: 230px;
  object-fit: contain;
}
.item-card-title {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 1.1) !important;
  display: flex;
  width: 230px;
}
.card-username {
  margin-left: 0.3rem;
  font-size: 11px;
  color: $grey;
  font-weight: normal;
}
.user-content {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
}
.card-poster-name {
  font-weight: bold;
}
.posted-info {
  color: $black !important;
  max-width: 85px;
}

.header-content {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}
.item-title {
  max-width: 150px;
}
</style>

<style lang="scss" scoped>
.item-price {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
}
.item-description {
  overflow: hidden;
  height: 63px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.item-actions {
  margin-right: -2.99rem;
}
.item-actions-lp {
  margin-right: -0.55rem !important;
}
.temporary-position {
  display: flex;
  justify-content: center;
}
.image {
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss" scoped>
.poster-name-content {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
}
.lp-poster-name-class {
  max-width: 70px;
}
</style>



<style lang="scss" scoped>
.skeleton {
  position: relative;
  overflow: hidden;
  background-color: $grey-light !important;
  color: transparent !important;
  border-color: $grey-light !important;
  user-select: none;
  cursor: default;
}

.skeleton img {
  opacity: 0;
}

.skeleton::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    $background-primary-1 20%,
    $background-primary-2 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 1.69s infinite;
  content: "";
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>

